const Data = {
  'Básico': [
    {
      index: 1,
      category: 'module1',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 1 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp"),
          featureId: "c65e2312-e3f6-4c0e-a913-cc0b225937c2",//probablemente mal
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 1 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp"),
          featureId: "be56349e-330b-49f4-ab4d-1179c721e6ad",
        },
      ]
    },
    {
      index: 2,
      category: 'module2',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 2 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp"),
          featureId: "c65e2312-e3f6-4c0e-a913-cc0b225937c2",//probablemente mal
        },
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 2 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp"),
          featureId: "20e127aa-fab5-4236-bb3d-4989804b5697",
        },
        {
          id: "murphy",
          name: "Murphy",
          price: '6,000,000',
          included: true,
          quote_text: 'Módulo 2 - Murphy',
          image: require("../assets/icons/piso1/espacio_cama.webp"),
          featureId: "bcd499c4-4a6e-418f-9667-35d4bae3ebec",
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 2 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp"),
          featureId: "be56349e-330b-49f4-ab4d-1179c721e6ad",//probablemente mal
        },
        {
          id: "sinmurphy",
          name: "Sin Murphy",
          price: '0',
          included: false,
          quote_text: 'Módulo 2 - Sin Murphy',
          image: require("../assets/icons/piso1/espacio_vacio.webp"),
          featureId: "",
        },
      ]
    },
    {
      index: 3,
      category: 'module3',
      options: [
        {
          id: "bolillo",
          name: "Bolillo",
          price: '2,000,000',
          included: true,
          quote_text: 'Módulo 3 - Bolillo',
          image: require("../assets/icons/piso1/espacio_closet.webp"),
          featureId: "c65e2312-e3f6-4c0e-a913-cc0b225937c2",//probablemente mal
        },
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 3 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp"),
          featureId: "8ca5b5ec-3594-4897-93ae-c6300ade9eda",//probablemente mal
        },
        {
          id: "murphy",
          name: "Murphy",
          price: '6,000,000',
          included: true,
          quote_text: 'Módulo 3 - Murphy',
          image: require("../assets/icons/piso1/espacio_cama.webp"),
          featureId: "bcd499c4-4a6e-418f-9667-35d4bae3ebec",
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 3 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp"),
          featureId: "be56349e-330b-49f4-ab4d-1179c721e6ad",//probablemente mal
        },
        {
          id: "sinmurphy",
          name: "Sin Murphy",
          price: '0',
          included: false,
          quote_text: 'Módulo 3 - Sin Murphy',
          image: require("../assets/icons/piso1/espacio_vacio.webp"),
          featureId: "",
        },
      ]
    },
    {
      index: 4,
      category: 'module4',
      options: [
        {
          id: "cajonera",
          name: "Cajonera",
          price: '2,700,000',
          included: true,
          quote_text: 'Módulo 4 - Cajonera',
          image: require("../assets/icons/piso1/espacio_closet+cajonera.webp"),
          featureId: "8ca5b5ec-3594-4897-93ae-c6300ade9eda",
        },
        {
          id: "escritorio",
          name: "Escritorio",
          price: '1,800,000',
          included: true,
          quote_text: 'Módulo 4 - Escritorio',
          image: require("../assets/icons/piso1/espacio_escritorio.webp"),
          featureId: "b8438d75-9566-42f5-b952-03263517e0c3",
        },
        {
          id: "cocina",
          name: "Cocina",
          price: '2,300,000',
          included: false,
          quote_text: 'Módulo 4 - Cocina .45',
          image: require("../assets/icons/piso1/espacio_almacenamiento.webp"),
          featureId: "5eaab42a-aa18-4079-b6bc-9638eb7ea21f",//probablemente mal
        },
      ]
    }
  ],
  'Liviano': [
    {
      index: 1,
      category: 'module1',
      options: [
        {
          id: "escritorio",
          name: "Escritorio Sencillo",
          price: '900,000',
          included: false,
          quote_text: 'Módulo 1 - Escritorio Sencillo',
          image: require("../assets/icons/mezanine/mezanine-escritorio.webp"),
          featureId: "b8438d75-9566-42f5-b952-03263517e0c3",
        },
        {
          id: "nodesk",
          name: "Sin Escritorio",
          price: '0',
          included: false,
          quote_text: 'Módulo 1 - Sin Escritorio',
          image: require("../assets/icons/mezanine/mezanine-noescritorio.webp"),
          featureId: "",
        }
      ]
    },
    {
      index: 2,
      category: 'module2',
      options: [
        {
          id: "lavamanos",
          name: "Lavamanos",
          price: '3,500,000',
          included: false,
          quote_text: 'Módulo 2 - Lavamanos + Cajonera',
          image: require("../assets/icons/mezanine/mezanine-lavamanos.webp"),
          featureId: "496e160b-81c1-4e59-b6b2-4ff0a77941fa",
        },
        {
          id: "cajonera",
          name: "Bolillo Superior",
          price: '1,000,000',
          included: false,
          quote_text: 'Módulo 2 - Bolillo Superior',
          image: require("../assets/icons/mezanine/mezanine-closet.webp"),
          featureId: "c65e2312-e3f6-4c0e-a913-cc0b225937c2",
        },
      ]
    }
  ],
  'ObraGris': [
  ],


}

module.exports = { Data };